import { Pipe, PipeTransform } from '@angular/core';
import { getClientApplicationIconPath } from 'src/app/common/aiServiceUtils';

@Pipe({
  name: 'clientApplicationIcon',
  standalone: true,
})
export class ClientApplicationIconPipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    return getClientApplicationIconPath(value);
  }
}
